/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CouponAmountOff,
    CouponAmountOffFromJSON,
    CouponAmountOffFromJSONTyped,
    CouponAmountOffToJSON,
} from './CouponAmountOff';
import {
    CouponRestrictions,
    CouponRestrictionsFromJSON,
    CouponRestrictionsFromJSONTyped,
    CouponRestrictionsToJSON,
} from './CouponRestrictions';
import {
    CouponV2AppliesTo,
    CouponV2AppliesToFromJSON,
    CouponV2AppliesToFromJSONTyped,
    CouponV2AppliesToToJSON,
} from './CouponV2AppliesTo';

/**
 * 
 * @export
 * @interface CouponCreateParamsV2
 */
export interface CouponCreateParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof CouponCreateParamsV2
     */
    program_id: string;
    /**
     * 
     * @type {CouponAmountOff}
     * @memberof CouponCreateParamsV2
     */
    amount_off?: CouponAmountOff;
    /**
     * A positive float larger than 0, and smaller or equal to 100, that represents the discount the coupon will apply (required if `amount_off` is not passed).
     * @type {number}
     * @memberof CouponCreateParamsV2
     */
    percent_off?: number;
    /**
     * Timestamp specifying the last time at which the coupon can be redeemed. After the redeem_before date, the coupon can no longer be applied to new customers.
     * @type {Date}
     * @memberof CouponCreateParamsV2
     */
    redeem_before?: Date;
    /**
     * 
     * @type {CouponV2AppliesTo}
     * @memberof CouponCreateParamsV2
     */
    applies_to?: CouponV2AppliesTo;
    /**
     * A value that determines whether the coupon is added if the order meets restrictions.
     * @type {boolean}
     * @memberof CouponCreateParamsV2
     */
    apply_automatically?: boolean;
    /**
     * The customer-facing code. Regardless of case, this code must be unique across all active promotion codes for a specific customer. If left blank, we will generate one automatically.
     * @type {string}
     * @memberof CouponCreateParamsV2
     */
    code?: string;
    /**
     * Timestamp specifying the first time at which the coupon can be redeemed. Before the redeem_after date, the coupon can not be applied.
     * @type {Date}
     * @memberof CouponCreateParamsV2
     */
    redeem_after?: Date;
    /**
     * 
     * @type {CouponRestrictions}
     * @memberof CouponCreateParamsV2
     */
    restrictions?: CouponRestrictions;
}

export function CouponCreateParamsV2FromJSON(json: any): CouponCreateParamsV2 {
    return CouponCreateParamsV2FromJSONTyped(json, false);
}

export function CouponCreateParamsV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponCreateParamsV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'program_id': json['program_id'],
        'amount_off': !exists(json, 'amount_off') ? undefined : CouponAmountOffFromJSON(json['amount_off']),
        'percent_off': !exists(json, 'percent_off') ? undefined : json['percent_off'],
        'redeem_before': !exists(json, 'redeem_before') ? undefined : (new Date(json['redeem_before'])),
        'applies_to': !exists(json, 'applies_to') ? undefined : CouponV2AppliesToFromJSON(json['applies_to']),
        'apply_automatically': !exists(json, 'apply_automatically') ? undefined : json['apply_automatically'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'redeem_after': !exists(json, 'redeem_after') ? undefined : (new Date(json['redeem_after'])),
        'restrictions': !exists(json, 'restrictions') ? undefined : CouponRestrictionsFromJSON(json['restrictions']),
    };
}

export function CouponCreateParamsV2ToJSON(value?: CouponCreateParamsV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_id': value.program_id,
        'amount_off': CouponAmountOffToJSON(value.amount_off),
        'percent_off': value.percent_off,
        'redeem_before': value.redeem_before === undefined ? undefined : (value.redeem_before.toISOString()),
        'applies_to': CouponV2AppliesToToJSON(value.applies_to),
        'apply_automatically': value.apply_automatically,
        'code': value.code,
        'redeem_after': value.redeem_after === undefined ? undefined : (value.redeem_after.toISOString()),
        'restrictions': CouponRestrictionsToJSON(value.restrictions),
    };
}

